// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"features-item_itemContainer__1AvRL","itemContainerRow":"features-item_itemContainerRow__1E14z","icon":"features-item_icon__2AhzI"};